<!-- ComponentIndexTravel -->

<template>
  <div style="
      display: flex;
      flex-direction: row;
      overflow-x: scroll;
      background-color: #ffffff;
      padding: 4px 0;
    ">
    <div v-for="(item, index) of travelData.records" :key="index" style="
        display: block;
        margin: 0 4px;
        background-color: #ffffff;
        text-align: center;
      " @click="
        $router.push({ path: 'travel-detail', query: { id: item.brandShopId } })
        ">
      <van-image :src="item.logo" fit="contain" height="120" lazy-load width="120" />
      <div class="van-ellipsis" style="width: 120px; font-size: 16px; margin-top: 8px">
        {{ item.name }}
      </div>

      <div style="
          display: flex;
          margin-top: 8px;
          justify-content: center;
          font-size: 12px;
        ">
        <van-tag style="font-size: 10px" type="warning">{{ getExtInfo(item.extInfo).commentGrade }}分</van-tag>
        <van-tag style="margin-left: 1px; font-size: 10px" text-color="#fff">{{ item.distance }}km</van-tag>
      </div>

      <div style="margin: 8px 0">
        <img
          src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
          style="
            width: 18px;
            height: 18px;
            display: block;
            margin-top: 4px;
            float: left;
          " />
        <span style="
            color: #f84f43;
            font-size: 18px;
            line-height: 24px;
            display: block;
            margin-top: 4px;
            float: left;
          ">
          {{ (item.goodsMinPrice / 100).toFixed(2) }}
          <span style="font-size: 12px">起</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { api_get_scenic_spot_list } from "@/api/goods-api";

export default {
  data() {
    return {
      travelData: {},
    };
  },

  mounted() {
    this.getTravelData_flag();
  },

  methods: {
    getExtInfo(str) {
      const extInfo = JSON.parse(str);
      return extInfo || {};
    },

    getTravelData_flag() {
      api_get_scenic_spot_list(this.pi, 10, "", 0, 1, 0, 0).then((res) => {
        this.travelData = {
          id: 7,
          records: res.data.records.filter((g) => g.goodsCount > 0),
        };
      });
    },
  },
};
</script>
